/**
 * Homepage hero slider helpers (Classic / Trendy / Medico / Mixy).
 *
 * Overlay shade + copy only when headline, subtitle, or CTA *button text* is set.
 * A CTA *link* alone does not add overlay; the whole banner becomes the link.
 */

export function trimSlideField(v) {
  return String(v || "").trim();
}

/** True when the merchant set visible copy (not a link-only slide). */
export function slideHasText(s) {
  return Boolean(
    trimSlideField(s?.title) || trimSlideField(s?.subtitle) || trimSlideField(s?.cta_text),
  );
}

export function slideCtaButtonText(s) {
  return trimSlideField(s?.cta_text);
}

/**
 * Resolve the slide href. Empty link is not treated as a destination unless
 * button text is set (then we fall back to #shop, matching older defaults).
 */
export function slideHeroHref(base, s, resolveHref) {
  const link = trimSlideField(s?.cta_link);
  const btn = slideCtaButtonText(s);
  if (link) return resolveHref(base, link);
  if (btn) return resolveHref(base, "#shop");
  return null;
}

/** Whole image is the hit target when a link exists and there is no button label. */
export function slideFullBannerClick(s) {
  return Boolean(trimSlideField(s?.cta_link) && !slideCtaButtonText(s));
}
